import React from "react";
import PropTypes from "prop-types";

import "./DisabledOverlay.css";

const DisabledOverlay = props => (
	!props.disabled ? null :
		<div className="almig-disabled-overlay" />
);

DisabledOverlay.propTypes = {
	disabled: PropTypes.bool
};

export default DisabledOverlay;
